(function () {
	'use strict';

    angular.module("imApp").factory("transportAreaService", ['$ihttp', function ($ihttp) {
		let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1399,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1400,
                    parameters: edit
                });
            }
		};

		return service;
	}]);
})();
